module.exports = __webpack_public_path__ + "static/media/HomeScreen_elImage2_1191308422.eae50edf.png";